// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';

// Relative Imports
import './AppContainer.less';
import actions from '../../actions/actions';
import helpActions from '../../actions/help';
import CreateAccount from '../CreateAccount/CreateAccountContainer';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import MainContent from '../MainContent/MainContent';
import Introduction from '../Introduction/IntroductionContainer';
import LandingPage from '../LandingPage/LandingPageContainer';
import SoftwareDetails from '../SoftwareDetails/SoftwareDetailsContainer';
import MailingInformation from '../MailingInformation/MailingInformationContainer';
import MasterBrand from '../MasterBrand/MasterBrandContainer';
import Currency from '../Currency';
import CurrencyV1 from '../Currency/v1/Currency'
import ListingModel from '../ListingModel';
import PurchaseOrder from '../PurchaseOrder';
import CompanyLocation from '../CompanyLocation/CompanyLocationContainer';
import Summary from '../Summary/SummaryContainer';
import Complete from '../Complete';
import InformationPage from '../InformationPage/InformationPageContainer';
import MultipleAccounts from '../MultipleAccounts/MultipleAccountsContainer';
import ConfirmBrand from '../ConfirmBrand/ConfirmBrandContainer';
import VatInformation from '../VatInformation/VatInformationContainer';
import BasicInformation from '../BasicInformation/BasicInformationContainer';
import PropertyCount from '../PropertyCount/PropertyCountContainer';
import ReviewPage from '../ReviewPage/ReviewPageContainer';
import ConfirmationPage from '../Confimation/ConfirmationPageContainer';
import BusinessModel from '../BusinessModel/BusinessModelContainer';
import {localizeUrl} from '@homeaway/localization-utils';
import {getPreferredLocale} from '../../utils/localStorageDataHandler';
import {FOP} from '../../utils/constants'
import BankingLocation from '../BankingLocation/BankingLocationContainer';
import PayoutDetails from '../PayoutDetails/PayoutDetailsContainer';

function mapStateToProps(state) {
    return {
        appState: state.app.appState,
        enableLoadOverlay: state.app.enableLoadOverlay,
        publicUuid: state.app.publicUuid,
        authState: state.app.authState,
        translations: state.app.translations,
        brandName: state.system.brandName,
        siteName: state.system.siteName,
        urlPrefix: state.app.config.urlPrefix,
        logoBrandName: state.system.logoBrandName,
        footerData: state.app.footerData,
        supportedLocales: state.app.supportedLocales,
        locale: state.system.locale,
        preferredLocale: state.system.preferredLocale,
        environment: state.system.environment,
        nodeEnvironment: state.system.nodeEnvironment,
        redirectPath: state.app.redirectPath,
        dyff: state.app.dyff
    };
}

function mapDispatchToProps(dispatch) {
    return {
        helpActions: bindActionCreators(helpActions, dispatch),
        actions: bindActionCreators(actions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
class AppContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        if (this.props.authState) {
            this.handlePreferredLocale();
        }

        if (this.props.redirectPath) {
            if (typeof window !== 'undefined') {
                let {protocol, host, pathname} = window.location;
                pathname = this.props.redirectPath;
                const appUrl = (pathname === '/') ? `${protocol}//${host}${pathname}` : `${protocol}//${host}${pathname}?site=vrbo`;
                window.location = appUrl;
            }
        }
    }

    componentDidMount() {
        window.history.pushState(
            '',
            '',
            localizeUrl(`/${this.props.urlPrefix}`, window.__SITE_CONTEXT__)
        );
    }

    handlePreferredLocale = () => {
        const {publicUuid, preferredLocale, authState} = this.props;

        if (authState) {
            const savedLocale = getPreferredLocale(publicUuid);
            if (savedLocale) {
                if(savedLocale !== preferredLocale) {
                    this.redirectToNewLocale(savedLocale);
                }
            } else if (!this.isLocaleRedirectEligible()) {
                this.props.actions.savePreferredLocale(publicUuid, preferredLocale);
            }
        }
    }

    isLocaleRedirectEligible = () => (this.props.locale === this.props.preferredLocale);

    redirectToNewLocale = (locale) => {
        if (typeof window !== 'undefined') {
            const {protocol, host, pathname, search} = window.location;
            const appUrl = `${protocol}//${host}${pathname}`;
            const localParamStr = `locale=${locale}`;
            window.location = search ? `${appUrl}${search}&${localParamStr}` : `${appUrl}?${localParamStr}`;
        }
    }

    redirectToFop = () => {
        const {siteName, environment, nodeEnvironment} = this.props;
        if (typeof window !== 'undefined') {
            let {protocol, host} = window.location;
            let {basePath} = window.__SITE_CONTEXT__;
            basePath = basePath || '';
            if (environment === 'development') {
                host = 'test.vrbo.com';
            } else if (environment === 'stage' && nodeEnvironment === 'development') {
                host = 'stage.vrbo.com';
            }
            let appUrl = `${protocol}//${host}${basePath}${FOP.suffix}?redirect=${FOP.query.redirect}`;
            if (siteName === 'homeaway_us') {
                appUrl = `${appUrl}&site=${siteName}`;
            }
            window.location.replace(`${appUrl}`);
        }
    };


    // eslint-disable-next-line complexity
    render() {
        const {
            appState,
            authState,
            translations,
            enableLoadOverlay,
            footerData,
            dyff
        } = this.props;

        let panelContent;
        let skipHeader = false;
        let skipMainContainer = true;
        let skipFooter = true;
        let isLandingPage = false;

        switch (appState) {
            case 'LANDING_PAGE':
                panelContent = <LandingPage />;
                isLandingPage = true;
                skipHeader = true;
                skipFooter = false;
                break;
            case 'CREATE_ACCOUNT':
                panelContent = <CreateAccount />;
                skipFooter = false;
                skipMainContainer = false;
                break;
            case 'INTRODUCTION':
                panelContent = <Introduction />;
                break;
            case 'SOFTWARE_DETAILS':
                panelContent = <SoftwareDetails />;
                break;
            case 'MAILING_INFORMATION':
                panelContent = <MailingInformation />;
                break;
            case 'SUMMARY':
                panelContent = <Summary />;
                break;
            case 'COMPANY_LOCATION':
                panelContent = <CompanyLocation />;
                break;
            case 'MASTER_BRAND':
                panelContent = <MasterBrand />;
                break;
            case 'CURRENCY_DETAILS':
                panelContent = <Currency />;
                break;
            case 'SUPPORTED_CURRENCY':
                panelContent = <CurrencyV1 />;
                break;
            case 'VAT_INFORMATION':
                panelContent = <VatInformation />;
                break;
            case 'LISTING_MODEL':
                panelContent = <ListingModel />;
                break;
            case 'PURCHASE_ORDER':
                panelContent = <PurchaseOrder dyff={dyff} />;
                break;
            case 'BILLING_INFORMATION':
                this.redirectToFop();
                break;
            case 'COMPLETE_PAGE':
            case 'PAYMENT_SETUP_COMPLETE':
                panelContent = <Complete />;
                break;
            case 'PROPERTY_COUNT':
                panelContent = <PropertyCount />;
                break;
            case 'ONBOARDING_STATUS_NOT_FOUND':
                panelContent = <InformationPage messageKey={'ACCESS_DENIED'} />;
                break;
            case 'INELIGIBLE':
                panelContent = <InformationPage messageKey={'NOT_ELIGIBLE'} />;
                break;
            case 'BASIC_INFORMATION':
                panelContent = <BasicInformation />;
                break;
            case 'REVIEW_PAGE':
                panelContent = <ReviewPage />;
                break;
            case 'CONFIRMATION_PAGE':
                panelContent = <ConfirmationPage />;
                break;
            case 'MULTIPLE_ACCOUNTS':
                panelContent = <MultipleAccounts />;
                break;
            case 'CONFIRM_BRAND':
                panelContent = <ConfirmBrand />;
                break;
            case 'BUSINESS_MODEL':
                panelContent = <BusinessModel />;
                break;
            case 'BANKING_LOCATION':
                panelContent = <BankingLocation />;
                break;
            case 'PAYOUT_DETAILS':
                panelContent = <PayoutDetails />;
                break;
            default:
                panelContent = <InformationPage messageKey={'ERROR'} />;
                break;
        }

        return (
            <div>
                <Header
                    authState={authState}
                    translations={translations}
                    skipComponent={skipHeader}
                    triggerEdapEvent={this.props.actions.triggerEdapEvent}
                    toggleHelpModal={this.props.helpActions.toggleHelpModal}
                    siteName={this.props.siteName}
                    changeAppState={this.props.actions.changeAppState}
                    isLandingPage={isLandingPage}
                    logoBrandName={this.props.logoBrandName}
                    supportedLocales={this.props.supportedLocales}
                    preferredLocale={this.props.preferredLocale}
                    savePreferredLocale={this.props.actions.savePreferredLocale}
                    publicUuid={this.props.publicUuid}
                    environment={this.props.environment}
                    nodeEnvironment={this.props.nodeEnvironment}
                    dyff={this.props.dyff}
                />
                <MainContent
                    panelContent={panelContent}
                    skipComponent={skipMainContainer}
                    enableLoadOverlay={enableLoadOverlay}
                />
                <Footer
                    translations={translations}
                    skipComponent={skipFooter}
                    isLandingPage={isLandingPage}
                    footerData={footerData}
                />
            </div>
        );
    }
}

AppContainer.propTypes = {
    appState: PropTypes.oneOf([
        'LANDING_PAGE',
        'CREATE_ACCOUNT',
        'INTRODUCTION',
        'SOFTWARE_DETAILS',
        'MAILING_INFORMATION',
        'SUMMARY',
        'COMPANY_LOCATION',
        'MASTER_BRAND',
        'CURRENCY_DETAILS',
        'SUPPORTED_CURRENCY',
        'VAT_INFORMATION',
        'LISTING_MODEL',
        'PURCHASE_ORDER',
        'BILLING_INFORMATION',
        'COMPLETE_PAGE',
        'PROPERTY_COUNT',
        'ONBOARDING_STATUS_NOT_FOUND',
        'INELIGIBLE',
        'BASIC_INFORMATION',
        'ERROR',
        'MULTIPLE_ACCOUNTS',
        'CONFIRM_BRAND',
        'BUSINESS_MODEL',
        'PAYOUT_DETAILS'
    ]),
    authState: PropTypes.bool,
    translations: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    enableLoadOverlay: PropTypes.bool,
    dyff: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default AppContainer;
